import { DefaultTemplate } from "@components/templates/default";


export function CalendarCreate() {


    return <DefaultTemplate>
        <h1>hola</h1>
    </DefaultTemplate>
}